import React, {Component} from 'react';
import { PagePanel } from '../../../components/helpers/PagePanel';
import '../Home.css'
import priceImage from '../../../assets/images/copenhagen-silhouette.jpg';
import Prices from "../../../components/prices/PricesTable";
import {Grid, Row, Col} from "react-bootstrap";
import {Link} from "react-router-dom";
import OCITraining from "../../../components/prices/OCI";

export class Pricing extends Component {
    render() {
        return <PagePanel className="prices" bgImage={priceImage}>
            <h1>Pricing</h1>
            <Prices/>
            <Grid>
                <Row className="text-center">
                    <Col xs={9}>
                        <OCITraining/>
                    </Col>
                    <Col xs={9}>
                        <p><small className="text-info">Terms and conditions apply. For more information see the <Link to="/registration">Registration</Link> page.</small></p>
                    </Col>
                </Row>

            </Grid>
        </PagePanel>
    }
}




// WEBPACK FOOTER //
// ./src/pages/home/fragments/Prices.js